import {faFontAwesome} from '@fortawesome/free-brands-svg-icons'
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faArrowDown,
    faArrowRight,
    faArrowUp,
    faBell,
    faCalendarAlt,
    faChartBar,
    faChartPie,
    faChevronLeft,
    faClipboardList,
    faCloudSunRain,
    faCommentDots,
    faDrawPolygon,
    faEdit,
    faFileContract,
    faFileInvoiceDollar,
    faHome,
    faLightbulb,
    faListAlt,
    faPlusSquare,
    faQuestionCircle,
    faRetweet,
    faShoppingBag,
    faShoppingCart,
    faSignOutAlt,
    faSquare,
    faSun,
    faTimes,
    faTint,
    faTrash,
    faUndo,
    faUser,
    faUserCircle,
    faUserEdit
} from "@fortawesome/free-solid-svg-icons";

library.add(faRetweet);
library.add(faClipboardList);
library.add(faSignOutAlt);
library.add(faUser);
library.add(faCommentDots);
library.add(faFileInvoiceDollar);
library.add(faTimes);
library.add(faArrowDown);
library.add(faArrowUp);
library.add(faUndo);
library.add(faDrawPolygon);
library.add(faTrash);
library.add(faCommentDots);
library.add(faFileContract);
library.add(faQuestionCircle);
library.add(faUserEdit);
library.add(faShoppingBag);
library.add(faListAlt);
library.add(faShoppingCart);
library.add(faLightbulb);
library.add(faChartPie);
library.add(faChartBar);
library.add(faTint);
library.add(faSun);
library.add(faPlusSquare);
library.add(faSquare);
library.add(faCalendarAlt);
library.add(faEdit);
library.add(faChevronLeft);
library.add(faCloudSunRain);
library.add(faArrowRight);
library.add(faBell);
library.add(faHome);
library.add(faUserCircle);
library.add(faFontAwesome)
